export default {
  setLoaded(state, loaded) {
    state.loaded = loaded
  },
  setAllowSuggestions(state, allowSuggestions) {
    state.allowSuggestions = allowSuggestions
  },
  setOffline(state, offline) {
    state.offline = offline
  },
  setNominees(state, nominees) {
    state.nominees = nominees
  },
  setCategories(state, categories) {
    state.categories = categories
  },
  setFrontend(state, frontend) {
    state.frontend = frontend
  },
  setRounds(state, rounds) {
    state.rounds = rounds
  },
  setShowtimesTags(state, showtimesTags) {
    state.showtimesTags = showtimesTags
  },
  setStationsTags(state, stationsTags) {
    state.stationsTags = stationsTags
  },
  selectNominee(state, { categoryId, nomineeId }) {
    const cleared = state.selected.filter(choice => !(choice.categoryId === categoryId))

    state.selected = cleared.concat([{ categoryId, nomineeId }])
  },
  addSuggestion(state, { categoryId, suggestionName, suggestionStation = '-' }) {
    const cleared = state.selected.filter(choice => !(choice.categoryId === categoryId))

    state.selected = cleared.concat([{ categoryId, suggestionName, suggestionStation }])
  },
  clearCategory(state, { categoryId }) {
    state.selected = state.selected.filter(choice => !(choice.categoryId === categoryId))
  },
  clearSelected(state) {
    state.selected = []
  },
  setSelectedChannelId(state, { categoryId, tagId }) {
    const category = state.categories.find(({ id }) => id === categoryId)

    category.selectedChannelId = category.selectedChannelId === tagId ? null : tagId
  },
  setSelectedDayPartId(state, { categoryId, tagId }) {
    const category = state.categories.find(({ id }) => id === categoryId)

    category.selectedDayPartId = category.selectedDayPartId === tagId ? null : tagId
  },
  setKeyword(state, { categoryId, keyword }) {
    const category = state.categories.find(({ id }) => id === categoryId)

    category.keyword = keyword
  },
  setSortType(state, { categoryId, sortType }) {
    const category = state.categories.find(({ id }) => id === categoryId)

    category.sortType = sortType
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js